var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _circle, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnCorrectPalm1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.146 54.95c.49 10.243 8.874 18.421 19.111 18.421 10.238 0 18.62-8.181 19.111-18.422H8.146z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.616 42.15c-3.6 2.7-2.7 9-2.7 13.5l4.05 3.6 11.25 1.35 13.95-.45c2.25.15 6.75-.63 6.75-4.95 0-5.4-2.25-5.85-11.7-12.6s-18-3.15-21.6-.45z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.45 35.45-4.017 19.848c-1.09.851-3.623 2.022-5.03-.1-1.76-2.65-2.022-3.622-1.13-8.033l1.965-9.703c.892-4.41 4.778-5.46 6.542-5.104 1.764.357 2.027 1.329 1.67 3.093z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.56 55.003a1 1 0 0 0 1.961.396l-1.96-.396zm-6.74-8.144a1 1 0 0 0 1.94.485l-1.94-.485zm8.701 8.54c.61-3.017 1.517-7.604 2.306-11.61.79-4.012 1.46-7.437 1.602-8.139l-1.96-.397c-.143.71-.817 4.146-1.605 8.149-.789 4.008-1.694 8.59-2.303 11.6l1.96.397zM50.43 35.65c.184-.906.276-1.877-.116-2.702-.434-.913-1.304-1.36-2.335-1.57l-.397 1.961c.734.148.877.365.926.468.09.19.136.588-.038 1.446l1.96.397zm-2.451-4.271c-1.15-.233-2.811.001-4.305.883-1.536.906-2.91 2.506-3.416 5.002l1.96.397c.388-1.915 1.402-3.045 2.473-3.677 1.113-.657 2.276-.77 2.891-.645l.397-1.96zm-7.72 5.885c-.71 3.506-1.967 7.717-2.437 9.595l1.94.485c.43-1.722 1.738-6.132 2.456-9.683l-1.96-.397z",
    fill: "#DEE5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.958 18.488c-.249 1.783-2.167 19.613-2.617 29.513-.083.594-2.598 2.019-5.807 1.572-4.011-.56-2.126-7.567-1.69-10.686l3.045-21.839c.248-1.783 1.834-3.38 4.063-3.068 2.228.31 3.317 2.28 3.006 4.508z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.79 47.1c-.45-7.2 1.919-26.83 2.167-28.612.311-2.228-.777-4.198-3.006-4.508-2.228-.311-3.814 1.285-4.063 3.068-.198 1.426-1.815 15.717-2.747 22.403",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.968 14.251v25.2c0 1.65-.63 4.95-3.15 4.95-3.15 0-4.05-2.7-4.05-5.4v-25.2c0-3.15 2.7-3.6 3.6-3.6.9 0 3.6.9 3.6 4.05z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.968 39.451v-25.2c0-3.15-2.7-4.05-3.6-4.05-.9 0-3.6.45-3.6 3.6v25.65",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.733 17.948 2.322 21.022c.445 4.025-1.196 5.565-3.433 5.812-2.236.247-3.677-.5-4.17-4.972L13.13 18.787c-.297-2.683.848-4.62 3.084-4.868 2.236-.247 4.174.898 4.52 4.029z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.492 39.451c-.659-5.964-2.482-18.999-2.759-21.503-.345-3.131-2.283-4.276-4.519-4.029-2.236.247-3.38 2.185-3.084 4.868L15.45 39.81",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m11.653 27.121 3.093 12.215c.884 3.49 1.878 7.416-1.501 8.736-2.704 1.056-4.116-1.589-4.484-3.043L4.563 28.453c-.442-1.745.424-3.822 2.606-4.374 2.18-.552 3.931.861 4.484 3.042z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.392 39.899c-1.326-5.235-3.187-10.597-3.74-12.778-.552-2.18-2.302-3.594-4.483-3.042-2.182.552-3.048 2.629-2.606 4.374L8.76 45.029",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.256 71.593c-9.273 0-16.933-7.402-17.427-16.658H8.083c.49 10.244 8.936 18.436 19.174 18.436 10.237 0 18.695-8.38 19.185-18.621h-1.757c-.483 9.267-8.155 16.843-17.429 16.843z",
    fill: "#DEE5F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.917 55.2v-9.856",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.073,
    y: 2.998,
    width: 48.181,
    height: 81,
    rx: 6,
    stroke: "#9BACD7",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.073 75.27h48.181v2.728a6 6 0 0 1-6 6H9.074a6 6 0 0 1-6-6v-2.729zM3.073 7.537a4.539 4.539 0 0 1 4.539-4.539h39.104a4.539 4.539 0 0 1 4.538 4.539H3.074z",
    fill: "#9BACD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.99,
    cy: 80.159,
    r: 2.444,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m39.053 58.875 3.326-3.61L58.62 70.234l-3.326 3.61z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m54.91 55.01 3.471 3.47-15.617 15.618-3.471-3.47z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCorrectPalm1);
export default __webpack_public_path__ + "static/media/un-correct-palm-1.535faf3ed6f853dee1dab89c9f8d0b09.svg";
export { ForwardRef as ReactComponent };